export const iconFontAwesomeShapesFolder = (
	<i className="fa-solid fa-folder"></i>
);
